import {
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  Button,
  Flex,
  Heading,
} from "@aws-amplify/ui-react";

export default function SwitchProfileViewTable({
  activeProfile,
  careGiversData = [],
  onStopSessionClick,
  onSwitchClick,
}) {
  return (
    <Flex direction={"column"}>
      <Heading>Users I can caregive</Heading>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell as="th">Actions</TableCell>
            <TableCell as="th">Given Name</TableCell>
            <TableCell as="th">Nickname</TableCell>
            <TableCell as="th" display={{ base: "none", medium: "block" }}>
              Username
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {careGiversData?.map((caregiver) => {
            return (
              <TableRow key={`spvt_cgd_${caregiver?.patientUserId}`}>
                <TableCell>
                  {activeProfile?.patientUserId === caregiver?.patientUserId ? (
                    <Button
                      size="small"
                      variation="destructive"
                      onClick={onStopSessionClick.bind(
                        this,
                        caregiver?.patientUserId
                      )}
                    >
                      STOP SESSION
                    </Button>
                  ) : (
                    <Button
                      size="small"
                      variation="primary"
                      onClick={onSwitchClick.bind(
                        this,
                        caregiver?.patientUserId,
                        caregiver?.givenName,
                        caregiver?.nickname
                      )}
                    >
                      SWITCH
                    </Button>
                  )}
                </TableCell>
                <TableCell>{caregiver?.givenName || ""}</TableCell>
                <TableCell>{caregiver?.nickname || ""}</TableCell>
                <TableCell display={{ base: "none", medium: "block" }}>
                  {caregiver?.username || ""}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Flex>
  );
}
